const config = {
    defaultPath: '/'
};

export default config;
